module.exports = __webpack_public_path__ + "img/dog.8fe7f28e.png";